import EditInput from './EditInput';

export default EditInput;
